import React, { Component } from "react";
import { TextField } from "reactackle";
import { isMobile } from "react-device-detect";
import "./photo.css";
import _ from "lodash";
import { compose } from "recompose";
import { withFirebase } from "../../../Firebase";
import { connect } from "react-redux";
import { v1 as uuidv1 } from "uuid";

class PhotoUpload extends Component {
  state = {
    uploading: false,
    progress: "0"
  };

  componentDidMount() {
    let newImages = [];
    let stateImages = [];
    if (this.props.images && this.props.images.length > 0) {
      newImages = this.props.images.map(image => {
        return {
          action: "",
          url: image.url,
          imageName: image.imageName,
          b64: "",
          blob: ""
        };
      });
      stateImages = this.props.images.map(image => {
        return {
          status: "DONE",
          url: image.url,
          imageName: image.imageName
        };
      });
    }
    this.setState(prevState => {
      return {
        ...prevState,
        images: newImages,
        stateImages: stateImages
      };
    });
  }

  b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  getImages = () => {
    if (this.state.images && this.state.images.length > 0) {
      return this.state.images.map((imgData, index) => {
        //console.log("chota image: " + imgData.url);
        if (imgData.action !== "REMOVE") {
          return (
            <div
              className="img"
              style={{
                backgroundImage:
                  imgData.url !== ""
                    ? "url('" + imgData.url + "')"
                    : "url(data:image/png;base64," + imgData.b64 + ")",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                maxWidth: "150px",
                border: "1px solid gainsboro"
              }}
              onClick={() => {
                let imgArray = _.cloneDeep(this.state.images);
                imgArray[index].action = "REMOVE";
                if (imgArray[index].url === "") {
                  imgArray.splice(index, 1);
                }

                let stateImgArray = _.cloneDeep(this.state.stateImages);
                stateImgArray[index].status = "REMOVING...";
                if (stateImgArray[index].url === "") {
                  stateImgArray.splice(index, 1);
                }

                this.setState(prevState => {
                  return {
                    ...prevState,
                    images: imgArray,
                    stateImages: stateImgArray
                  };
                });

                this.props.stateChangeHandler(
                  imgArray,
                  this.props.fieldName,
                  false
                );

                this.props.stateChangeHandler(
                  stateImgArray,
                  this.props.fieldName,
                  true
                );
              }}
            >
              <span
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  color: "red"
                }}
              >
                <i
                  className="fa fa-times-circle fa-lg"
                  style={{ backgroundColor: "white" }}
                />
              </span>
            </div>
          );
        }
      });
    }
  };

  uploadImage = evtFiles => {
    try {
      console.log("triggering inside uploadImage function");
      let imageName = uuidv1() + ".jpg";
      const Compress = require("compress.js");
      const compress = new Compress();
      const files = [...evtFiles];
      compress
        .compress(files, {
          size: 2, // the max size in MB, defaults to 2MB
          quality: 1, // the quality of the image, max is 1,
          maxWidth: 300, // the max width of the output image, defaults to 1920px
          maxHeight: 300, // the max height of the output image, defaults to 1920px
          resize: true // defaults to true, set false if you do not want to resize the image width and height
        })
        .then(data => {
          //console.log("after conversion: " + JSON.stringify(data));
          let imgArray = [];
          let stateImgArray = [];
          if (this.state.images && this.state.images.length > 0) {
            imgArray = _.cloneDeep(this.state.images);
          }
          if (this.state.stateImages && this.state.stateImages.length > 0) {
            stateImgArray = _.cloneDeep(this.state.stateImages);
          }
          imgArray.push({
            action: "ADD",
            imageName: imageName,
            url: "",
            b64: data[0].data,
            blob: this.b64toBlob(data[0].data)
          });
          stateImgArray.push({
            status: "UPLOADING...",
            imageName: imageName,
            url: ""
          });
          this.setState(prevState => {
            return {
              ...prevState,
              images: imgArray,
              stateImages: stateImgArray
            };
          });
          this.props.stateChangeHandler(imgArray, this.props.fieldName, false);
          this.props.stateChangeHandler(
            stateImgArray,
            this.props.fieldName,
            true
          );
        });
    } catch (err) {
      alert(err);
    }
  };

  getViewOnlyImages = () => {
    if (this.props.images && this.props.images.length > 0) {
      return this.props.images.map(photo => {
        return (
          <div
            style={{
              textAlign: "center"
            }}
          >
            <img
              src={
                "https://storage.googleapis.com/bcsfbtest/images/" +
                photo.imageName
              }
              style={{
                maxHeight: "200px",
                maxWidth: "200px",
                height: "200px",
                width: "200px",
                borderRadius: "10px",
                border: "0px solid gainsboro",
                objectFit: "contain",
                position: "abosolute",
                top: "0",
                left: "0",
                zIndex: "2"
              }}
            />
          </div>
        );
      });
    }
  };

  render() {
    return (
      <div
        className="row"
        style={{
          marginLeft: "1px",
          marginRight: "1px",
          alignItems: "center",
          padding: "2px",
          border: "0px",
          borderBottom: "0px",
          borderBottomColor: "#cccccc",
          borderStyle: "solid",
          paddingBottom: isMobile ? "0px" : "2px"
        }}
      >
        <div
          className="col-sm-4 align-self-center”"
          style={{
            margin: "0px",
            verticalAlign: "middle",
            height: "auto",
            padding: "0px"
          }}
        >
          <div
            style={{
              marginTop: isMobile ? "13px" : "0px",
              verticalAlign: "middle",
              lineHeight: isMobile ? "20px" : "37px",
              padding: "0px",
              color: isMobile ? "black" : "black",
              marginBottom: isMobile ? "-1px" : "0px"
            }}
          >
            {this.props.title}
          </div>
        </div>
        <div
          className="col-sm-8"
          style={{
            padding: "1px",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor: "white",
            minHeight: "100px"
          }}
        >
          <div>
            {!this.props.disabled && (
              <div className="images">{this.getImages()}</div>
            )}
            {!this.props.disabled && (
              <div>
                <label
                  for="uploader"
                  style={{
                    padding: "1px",
                    textAlign: "right",
                    border: "1px solid gainsboro",
                    borderRadius: isMobile ? "5px" : "0px",
                    backgroundColor: "#2196F3",
                    margin: "5px",
                    padding: "6px",
                    fontWeight: "bold",
                    color: "white"
                  }}
                >
                  <i className="fa fa-plus"></i> TAP TO ADD PHOTO
                </label>
              </div>
            )}
            {this.props.disabled && <div>{this.getViewOnlyImages()}</div>}
          </div>
        </div>

        <input
          type="file"
          accept="image/*"
          id="uploader"
          onChange={evt => {
            console.log("clicked");
            //console.log("triggering main function");
            event.preventDefault();

            if (evt.target.files[0]) {
              this.uploadImage(evt.target.files);
            } else {
              console.log("gotcha");
            }
          }}
          style={{
            visibility: "hidden"
          }}
        />
      </div>
    );
  }
}

export default compose(
  connect(
    null,
    null
  ),
  withFirebase
)(PhotoUpload);



// WEBPACK FOOTER //
// ./src/app/components/Screens/FieldsComponents/PhotoUpload/PhotoUpload.jsx